<template>
  <div class="wechat-share" v-show="show">
    <div class="wechat-share-box">
      <icon
        type="iconic_cancel_pop"
        class="wechat-share-close"
        @click="handleClose"
      ></icon>

      <div class="wechat-share-pc">
        <div class="wechat-share-txt">复制链接，电脑端分享</div>
        <div class="wechat-share-input">
          <input v-model="url" ref="input" />
          <button @click="handleCopy">复制链接</button>
        </div>
      </div>
      <div class="wechat-share-mobile">
        <qrcode
          class="wechat-share-qrcode"
          :value="shareUrl"
          :size="130"
        ></qrcode>

        <div class="wechat-share-txt">打开手机微信</div>
        <div class="wechat-share-txt">扫描二维码一键分享好友</div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoPng from '@/assets/image/ic-logo.png';
import Qrcode from '@/components/qrcode';

export default {
  data() {
    return {
      show: false,
      LogoPng,
      url: '',
    };
  },

  props: {
    shareUrl: String,
  },

  components: {
    Qrcode,
  },

  methods: {
    handleClose() {
      this.show = false;
    },

    handleCopy() {
      this.$refs.input.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successfully' : 'unsuccessfully';
        console.log('text coppied ' + msg);
      } catch (err) {
        console.log('unable to copy text');
      }
    },
  },

  mounted() {
    this.url = window.location.href;
  },
};
</script>

<style lang="scss" scoped>
.wechat-share {
  @include popup-style();

  &-box {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 644px;
    height: 250px;
    padding: 40px 72px;
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
  }

  &-close {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 18px;
    cursor: pointer;
    opacity: 0.2;

    &:hover {
      opacity: 0.5;
    }
  }

  &-txt {
    font-size: 12px;
    line-height: 18px;
    color: #999999;
  }

  &-pc {
    width: 330px;
    margin-top: 40px;
  }

  &-input {
    @include flex-align-center();
    margin-top: 10px;

    > input {
      flex: 1;
      height: 38px;
      padding: 8px 12px;
      border: 1px solid #417ff9;
      border-radius: 25px 0 0 25px;
      color: #88b0ff;
      font-size: 12px;
      border-right: none;
      display: block;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

      &:focus {
        outline: 0;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
          0 0 8px rgba(102, 175, 233, 0.6);
      }
    }

    > button {
      height: 38px;
      background: #417ff9;
      color: #fff;
      border: 1px solid #417ff9;
      border-radius: 0 19px 19px 0;
      cursor: pointer;
      padding: 8px 12px;
    }
  }

  &-mobile {
    @include flex-align-center();
    flex-direction: column;
  }

  &-qrcode {
    @include flex-center();
    width: 140px;
    height: 140px;
    margin-bottom: 8px;
  }
}
</style>